export const idX = (x: any) => x;
